import { createContext, useContext } from 'react';

import { ContentType } from 'application-types';

export type ContentEditorContextType = {
  onContentUpdated?: (content: Partial<ContentType>) => void;
};

export const ContentEditorContext = createContext<ContentEditorContextType>({});

export function useContentEditorContext(): ContentEditorContextType {
  return useContext(ContentEditorContext);
}
